<template>
  <div class="doorlock-log-modal">
    <div class="page-search-block">
      <el-button type="primary" @click="backToLock">返回</el-button>
      <span class="m-l-20 bold">门锁编码：{{ equipCode }}</span>
      <span class="m-l-20 bold">房源名称：{{ roomName }}</span>
    </div>

    <div class="page-operate-block">
      <span class="page-title">开锁记录</span>
      <i :class="`float-r fa icon-eye ${isEncry ? 'fa-eye-slash' : 'fa-eye'}`" @click="changeEncry"></i>
    </div>
    
    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      ></r-table>
    </div>

    <el-image-viewer v-if="showViewer" class="capture-big-image" :on-close="closeViewer" :url-list="captureSrcList" />
    
    <RModal
      customClass="bigModalDialog"
      title="开锁照片"
      top="5vh"
      :show="showModal"
      :closeOnClick="false"
      width="1280px"
      @change="showModal = false"
      @close="showModal = false"
    >
      <template #content>
        <ImageView :log-data="selectedRow" />
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal"
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'

import ImageView from './imgViewDialog.vue'

import { ElImageViewer } from 'element-plus'

export default {
  name: 'equipDoorlockLogPage',
  mixins: [tableMix, checkMix],
  components: { RModal, RTable, ElImageViewer, ImageView },
  props: {
    equipCode: { type: [String, Number], default: '' },
    roomName: { type: String, default: '--' },
    roomCode: { type: String, default: '--' },
  },
  data() {
    return {
      showModal: false,
      selectedRow: {},

      tableVarity: 'equip-doorlock-log-table',
      showViewer:false,
      captureSrcList:['http://10.10.109.103:5569/saas/upgradePackage/house/反2.jpg','http://10.10.109.103:5569/saas/upgradePackage/house/09.jpg'],

      isEncry: true, // 是否加密状态

      tableColumn: [],
      tableData: [],
      options: {
        multiSelect: false, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: false,
        selection: false,
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      selOptions: { unlockType: [] },
      selOptionMaps: { unlockType: {} }
    }
  },
  created() {
    this.getDictData(['unlockType'])
    this.initTableColumns()
  },
  methods: {
    // 获取字典数据
    getDictData(types) {
      if (!types || !types.length) return

      let url = 'RESOURCE.GET_MULTI_LIST'
      let params = types.map(item => `types=${item}`).join('&')

      this.fetchData({ url, method: "get", params, isGetParamsDirect: true }).then((res) => {
        if (!res) {
          return console.log(types, '==== 字典获取失败');
        }
        for (let key in res) {
          this.selOptions[key] = res[key]
          this.selOptionMaps[key] = {}
          res[key].forEach(item => {
            this.selOptionMaps[key][item.name] = item.value
          })
        }
      }).finally(res => {
        this.getDataList()
      });
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = {
        roomCode: this.roomCode,
        deviceCode: this.equipCode,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      }

      let url = 'DEVICE.GET_LOCK_LOG_LIST'
      this.fetchData({ url, method: 'get', params }).then((res) => {
        if (!res || !res.data) {
          this.tableData = []
          this.pagination.total = 0
        } else {
          this.tableData = res.data || []
          this.pagination.total = res.rowCount
        }
      }).catch((err) => {
        console.log(err, 'errorInfo')
      }).finally(() => {
        this.options.loading = false
      })
    },
    // 切换加密视野
    changeEncry() {
      this.isEncry = !this.isEncry
      this.initTableColumns()
    },
    // 初始化自定义表头
    initTableColumns() {
      // 表头 visible：默认可见
      let columns = [
        { prop: 'unlockName', label: '开锁人', minWidth: 160 },
        // { prop: 'idNumber', label: '证件号码', minWidth: 200 },
        // { prop: 'idNumberType', label: '证件类型', minWidth: 200 },
        { prop: 'phone', label: '手机号码', minWidth: 160 },
        { prop: 'unlockType', label: '开锁类型', minWidth: 160 },
        { prop: 'unlockTime', label: '开锁时间', minWidth: 170 },
        { prop: 'pictures', label: '开锁照片', minWidth: 90 },
      ]

      columns.forEach((item) => {
        if (item.prop === 'unlockType') {
          item.render = (row, index, column) => {
            return <span>{ this.selOptionMaps.unlockType[row.unlockType] || '--' }</span>
          }
        } else if (item.prop === 'unlockName') {
          item.render = (row, index, column) => {
            let temp = row.unlockName || ''
            if (this.isEncry && temp) {
              let len = temp.length
              temp = temp.substr(0, 1) + this.getEncryStr(len - 1)
            }
            return <span>{ temp || '--' }</span>
          }
        } else if (item.prop === 'phone') {
          item.render = (row, index, column) => {
            let temp = row.phone || ''
            if (this.isEncry && temp) {
              temp = temp.substr(0, 3) + this.getEncryStr(4) + temp.substr(7)
            }
            return <span>{ temp || '--' }</span>
          }
        } else if (item.prop == 'pictures') {
          item.render = (row, index, column) => {
            // 测试数据
            // row.captureRecordDTOList = [
            //   { faceUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', faceBgUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', captureTime: '2022-03-18 11:04:06' },
            //   { faceUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', faceBgUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', captureTime: '2022-03-18 11:04:06' },
            //   { faceUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', faceBgUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', captureTime: '2022-03-18 11:04:06' },
            //   { faceUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', faceBgUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', captureTime: '2022-03-18 11:04:06' },
            //   { faceUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', faceBgUrl: 'https://pic2.zhimg.com/80/v2-de05d44acc247cdd700405c0543822ce_400x224.png', captureTime: '2022-03-18 11:04:06' },
            // ]
            if (!row.captureRecordDTOList) {
              return <span style="color:#909399">没有开锁照片</span>
            }
            return (
              <a onClick={ this.handleShowImg.bind(this, row) }>
                点击查看
              </a>
            );
          }
        }
      })

      this.tableColumn = columns
    },
    // 打开弹框显示图片
    handleShowImg(data) {
      this.showModal = true
      this.selectedRow = data
    },
    // 返回多少个 *
    getEncryStr(count) {
      let str = ''
      for (let i = 0; i < count; i++) {
        str += '*'
      }
      return str
    },
    backToLock() {
      this.$emit('change-view')
    },
    //关闭抓拍
    closeViewer(){
      this.showViewer = false
    },
  },
}
</script>

<style lang="less" scoped>
.page-operate-block {
  text-align: unset !important;
  .page-title {
    font-size: 20px;
    font-weight: bold;
  }
}
.top-oper-bar {
  align-items: center;
  margin-right: 5px;
}
.log-title {
  font-size: 22px;
  font-weight: 600;
  color:#333;
}
.capture-big-image {
  z-index:10001 !important;
}
.float-r {
  float: right;
}
</style>
